import React from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import { detectMobile } from "../../../services/utils";

bootstrapUtils.addStyle(Button, "grey");

function UiButton(props) {
  const { onClick, disabled, children, className } = props;

  const isMobile = detectMobile();
  const style = disabled === true ? "grey" : "primary";
  const btnClassName = className
    ? `btn-op-decisions-button ${className}`
    : "btn-op-decisions-button";

  return (
    <Button
      className={btnClassName}
      bsStyle={style}
      bsSize={isMobile === true ? "sm" : null}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}

export default UiButton;



// WEBPACK FOOTER //
// ./src/components/operations/decisions/ui-button.js